import request from '@/utils/request'
const PREFIX = '/fmis'
// 查询入账和结账所用的应收账套列表
export function getAccountList(data) {
  return request({
    url: `${PREFIX}/receiveAccountController/reAccountByCompanyIds`,
    method: 'post',
    data
  })
}

// 查询 调账 所用的应收账套列表
export function getAdjustFinanceAccountList() {
  return request({
    url: `${PREFIX}/receiveAccountController/receiveAccountListByHotelCode`,
    method: 'get',
  });
}

// 点击查看更多、查看账务详情
export function getAccountDetail(data) {
  return request({
    url: `${PREFIX}/account/roomAccountDetail`,
    method: 'post',
    data,
    notCheckRepeat: true
  })
}
// 获取付款科目报表的付款科目列表
export function fetchSubjectList(data) {
  return request({
    url: '/fmis/subjectController/getSubjectList',
    method: 'post',
    data
  })
}

/** *预授权相关接口 */
// 添加预授权
export function addPreAuth(data) {
  return request({
    url: '/order/preAuth/addPreAuth',
    method: 'post',
    data
  })
}
// 更新预授权
export function updatePreAuth(data) {
  return request({
    url: '/order/preAuth/updatePreAuth',
    method: 'post',
    data
  })
}
// 取消预授权
export function cancelPreAuth(data) {
  return request({
    url: '/order/preAuth/cancelPreAuth',
    method: 'post',
    data
  })
}
// 预授权结算
export function settlePreAuth(data) {
  return request({
    url: '/order/preAuth/settlePreAuth',
    method: 'post',
    data
  })
}
// 查询预授权列表
export function fetchPreAuthList(data) {
  return request({
    // url: '/pay/authorizelog/queryAuthorizeList',
    url: '/fmis/authorizelog/queryAuthorizeList',
    method: 'post',
    data
  })
}
// 查询预授权科目
export function fetchPreAuthSubjectList(params) {
  return request({
    // url: '/pay/authorizelog/getAuthorizeSubject',
    url: '/fmis/authorizelog/getAuthorizeSubject',
    method: 'get',
    params
  })
}
// 查询预授权金额
export function fetchPreAuthBalance(params) {
  return request({
    // url: '/pay/authorizelog/getAuthorizeMoney',
    url: '/fmis/authorizelog/getAuthorizeMoney',
    method: 'get',
    params
  })
}
// 批量查询预授权金额
export function groupFetchPreAuthBalance(params) {
  return request({
    // url: '/pay/authorizelog/getAuthorizeMoneyByRoomOrderNoList',
    url: '/fmis/authorizelog/getAuthorizeMoneyByRoomOrderNoList',
    method: 'post',
    data: params,
    notCheckRepeat: true
  })
}
// 查看财务列展开行里面的会员信息
export function queryFmisMemberDetail(data) {
  return request({
    url: '/fmis/subjectController/getMemberRefundRecord',
    method: 'post',
    data
  })
}

// 查询授权订单状态  仅支付线上收款预授权查询
export function queryPreAuth(data) {
  return request({
    url: '/order/preAuth/queryPreAuth',
    method: 'post',
    data
  })
}

// 结算查询是否可以部分结账
export function noSupportPartConfirm(data) {
  return request({
      url: '/fmis/api/authorize/noSupportPartConfirm',
      method: 'post',
      data
  })
}

// 消费科目类别列表
export function queryFmiscustomBelongList(params) {
  return request({
    url: '/fmis/subjectController/customBelongI18nList',
    method: 'get',
    params,
  });
}

// 消费科目列表
export function queryFmiscustomSubjectList(params) {
  return request({
    url: '/fmis/subjectController/customSubjectList',
    method: 'get',
    params,
  });
}

// 消费科目详情
export function queryFmiscustomSubjectDetail(params) {
  return request({
    url: '/fmis/subjectController/getSubjectDetailByHotelCodeAndSubjectCode',
    method: 'get',
    params,
  });
}

// 一级科目有序编码
export function queryFmispSubjects(params) {
  return request({
    url: '/fmis/subjectController/pSubjects',
    method: 'get',
    params,
  });
}

// 付款科目列表
export function queryFmispsettleSubjectList(params) {
  return request({
    url: '/fmis/subjectController/settleSubjectList',
    method: 'get',
    params,
  });
}

// 删除科目
export function queryFmisdel(data) {
  return request({
    url: '/fmis/subjectController/del',
    method: 'post',
    data,
  });
}

// 启用/禁用
export function queryFmisonOff(data) {
  return request({
    url: '/fmis/subjectController/onOff',
    method: 'post',
    notCheckRepeat: true,
    data,
  });
}

// 科目保存或编辑
export function queryFmissaveOrUpdate(data) {
  return request({
    url: '/fmis/subjectController/saveOrUpdate',
    method: 'post',
    data,
  });
}

// 一级科目排序
export function queryFmissort(data) {
  return request({
    url: '/fmis/subjectController/sort',
    method: 'post',
    data,
  });
}

// 获取付款科目报表的付款科目列表
export function getAllSubjectsUnderRoomOrderNos(data) {
  return request({
    url: '/fmis/subjectController/getAllSubjectsUnderRoomOrderNos',
    method: 'post',
    data,
  });
}
